import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { FormControl } from 'material-ui/Form';
import { MenuItem } from 'material-ui/Menu';
import Select from 'material-ui/Select';

const styles = () => ({
  root: {
    fontSize: '16px',
    color: '#181819',
    fontWeight: 'bold',
    paddingBottom: '9px',
    borderBottom: '1px solid #E7E9EB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  left: {
    display: 'flex',
    alignItems: 'center',
  },

  coltwo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: '0 12px',
    fontWeight: 'normal',
  },

  select: {
    border: 'none',
    fontSize: '13px'
  },

  paper: {
    maxHeight: 'unset'
  },

  flex: {
    flex: 1,
  },

});

class ListLabel extends React.Component {
  render() {
    const { classes, title } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.left}>
          <Typography variant="subheading" style={{ fontSize: '16px' }}>{title}</Typography>
        </div>

        <div className={classes.coltwo}>
          <div className={classes.flex}></div>

          {this.props.sortType && (<FormControl>
            <Select
              value={this.props.sortType}
              onChange={e => this.props.handleSortTypeChange(e.target.value)}
              classes={{ select: classes.select }}
              disableUnderline={true}
              MenuProps={{
                classes: {
                  paper: classes.paper,
                }
              }}
            >
              {Object.values(this.props.sortTypes).map(item => (
                <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
              ))}
            </Select>
          </FormControl>)}
        </div>
      </div>
    )
  }
}

ListLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  sortType: PropTypes.number,
  sortTypes: PropTypes.object,
  handleSortTypeChange: PropTypes.func,
};

export default withStyles(styles)(ListLabel);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/parts/ListLabel.jsx